"use client"; // Error components must be Client Components
import { useEffect } from "react";
import { GetDefaultImagePath } from "@/components/common/defaultImage/DefaultImage";
import { DefaultImage404 } from "@/components/common/defaultImage/DefaultPaths";
import { useDefaultPageContent } from "@/sanity/Sanity";
import { useState } from "react";
import { SanityImage } from "@/sanity/SanityImage";

export default function ErrorVDP({ error, reset }) {
    const [pageData, setPageData] = useState(null);

    console.log(error);
    // useDefaultPageContent returns promise, save in pageData and use
    useEffect(() => {
        useDefaultPageContent()
            .then((data) => {
                setPageData(data);
            })
            .catch((error) => {
                console.error("Error fetching data from Sanity", error);
            });
    }, []);

    if (!error) {
        return null;
    }

    return (
        <>
            <div>
                <div className="error t-flex t-justify-center t-items-center t-min-h-screen">
                    <div className="card404 t-p-8 t-text-center">
                        <h1>404</h1>
                        <p>Data not found!</p>
                        <hr className="t-my-4" />
                        {pageData && pageData.image ? (
                            <SanityImage
                                src={pageData.image}
                                alt=""
                                width={410}
                                height={360}
                                //   className="img-fluid mx-auto default-page-image"
                            />
                        ) : (
                            <img
                                src={GetDefaultImagePath(DefaultImage404)}
                                alt=""
                                width={410}
                                height={380}
                            />
                        )}
                        <hr className="t-my-4" />

                        <p className="t-my-4">Please check the VIN</p>
                        <p>
                            <span>
                                <a href="/cars">Click here</a>
                            </span>{" "}
                            to go back
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}
